// We can push anything to the dataLayer
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const trackGTMEvent = (props: any) => {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push(props);
  }
};
